import { useQuery } from '@tanstack/react-query';
import { type Company, MigrationStatus } from 'src/secret-menu/hooks/useCompanies';

export function usePollMigrationStatus(
  companyId: string | null,
  enabled: boolean,
): MigrationStatus | undefined {
  const { data: companies } = useQuery<Company[]>({
    queryKey: ['admin', 'companies'],
    refetchInterval: 2000,
    enabled: enabled && !!companyId,
  });

  return companies?.find(c => c.id === companyId)?.migrationStatus;
}
